/**
 * Payroll callable wrappers (all gen-1 us-east1, PayrollAdmin-gated
 * server-side — see functions/Payroll/auth.js). Every helper returns
 * `res.data` and lets HttpsError codes bubble to the caller.
 */

import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '../../utils/init-firebase';

const functions = getFunctions(app, 'us-east1');

const call = (name, timeout) => async (payload) => {
  const fn = httpsCallable(functions, name, timeout ? { timeout } : undefined);
  const res = await fn(payload || {});
  return res.data;
};

export const payrollApi = {
  listRuns: call('payrollListRuns'),
  getRunDetail: call('payrollGetRunDetail'),
  // Backtest reads ~900 pipeline rows + writes 90 result rows; allow 9 min.
  backtest: call('payrollBacktest', 540000),
  // Dry run computes every unprocessed row and persists the full preview.
  dryRun: call('payrollDryRun', 540000),
  // Live run (SuperAdmin): pipeline + workbook writes. Preflight = modal checklist.
  livePreflight: call('payrollLivePreflight', 120000),
  liveRun: call('payrollLiveRun', 540000),
  // One-click rehearsal: copies both sheets fresh, runs payroll on the copies.
  rehearsalRun: call('payrollRehearsalRun', 540000),
  importReference: call('payrollImportReference', 300000),
  getReferenceSnapshot: call('payrollGetReferenceSnapshot', 120000),
  // SuperAdmin one-time utilities (audited server-side).
  setupPipelineColumns: call('payrollSetupPipelineColumns', 300000),
  backfillLegacyRows: call('payrollBackfillLegacyRows', 300000),
  // Calculator (Phase 7).
  getMonthCounts: call('payrollGetMonthCounts', 120000),
  getPipelineRow: call('payrollGetPipelineRow', 120000),
  // Pipeline tab.
  getPipelineGrid: call('payrollGetPipelineGrid', 120000),
  updatePipelineCell: call('payrollUpdatePipelineCell', 60000),
  saveGoldenCase: call('payrollSaveGoldenCase', 60000),
  listGoldenCases: call('payrollListGoldenCases', 60000),
  // Reference management (Phase 8).
  manageReference: call('payrollManageReference', 120000),
  getConfig: call('payrollGetConfig', 60000),
  setConfig: call('payrollSetConfig', 60000),
  listAudit: call('payrollListAudit', 60000),
  // Schedule tab: list/create/update/delete/run_now — run_now executes the
  // full dry→gate→(live) flow server-side, so it gets the long timeout.
  manageSchedules: call('payrollManageSchedules', 540000),
};

export const isPermissionDenied = (err) =>
  !!err && (err.code === 'functions/permission-denied' || err.code === 'permission-denied');
